import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageSubComponent } from './components/page-sub/page-sub.component';
import { PageComponent } from './components/page/page.component';
import { PolicyComponent } from './components/policy/policy.component';
import { SitemapComponent } from './components/sitemap/sitemap.component';

const routes: Routes = [
  {
    path: 'institucional',
    component: PageComponent,
    children: [{ path: ':slug', component: PageSubComponent }],
  },
  { path: 'politica-de-privacidade', component: PolicyComponent },
  { path: 'mapa-do-site', component: SitemapComponent },
  { path: 'sitemap', component: SitemapComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PageRoutingModule {}
